import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `AjusteStock/addAjusteStock`, method: 'POST', body: values, token: token})
}
